import { useQuery } from '@tanstack/react-query'
import { fuzzySearchUsers } from 'api/users/fuzzySearchUsers'
import { fuzzySearchUserKey } from './keys'

export function useFuzzySearchUsersQuery({
  search,
  limit = 10,
  enabled = true,
}: {
  search: string
  limit?: number
  enabled?: boolean
}) {
  return useQuery({
    queryKey: fuzzySearchUserKey(search, limit),
    queryFn: () => fuzzySearchUsers(search, limit),
    enabled: enabled && search.trim().length > 0,
  })
}
